import { CicoPaymentMethod } from "@comparaonline/cico-funnel-schema";
import { AllowedPaymentMethod } from "@comparaonline/ui-checkout-cico";
import { Offer } from "@comparaonline/offers-models";
import { FINESA_INSTALLMENTS_COUNT } from "../constants";
import { getPaymentMethodsByOffer } from "../../cikmcl/helpers";

export const getAllowedPaymentMethods = (offer: Offer): AllowedPaymentMethod[] => {
  const paymentMethods = getPaymentMethodsByOffer<CicoPaymentMethod>(offer) || [
    CicoPaymentMethod.Financed,
    CicoPaymentMethod.DirectToCompany
  ];
  const {
    mainAttribute: {
      value: { installments, total, amount: oldTotal, monthlyInterest = 0 }
    }
  } = offer.product;

  const amount = total || oldTotal;

  return paymentMethods.map((name: CicoPaymentMethod) => {
    const isFinanced = name === CicoPaymentMethod.Financed;

    if (!isFinanced) return { name, amount };

    return {
      name,
      amount: getInstallmentPrice(installments, amount), // eslint-disable-line @typescript-eslint/no-use-before-define
      installments: FINESA_INSTALLMENTS_COUNT,
      interest: monthlyInterest
    };
  });
};

function getInstallmentPrice(installments, totalPrice) {
  const installmentData =
    installments &&
    installments.creditAccount &&
    installments.creditAccount[FINESA_INSTALLMENTS_COUNT];
  return installmentData ? installmentData.price : totalPrice / FINESA_INSTALLMENTS_COUNT;
}
